import { useEffect, useRef } from 'react';
import { SliderSt } from './Slider.css';

const Slider = ({ children, handleBackClick, handleNextClick }) => {
  const sliderContainer = useRef();

  useEffect(() => {
    if (!sliderContainer.current) {
      return;
    }

    const el = sliderContainer.current as HTMLElement;
    let xStart = null;

    const handleTouchStart = ({ touches }) => {
      if (touches.length > 1) {
        xStart = null;
        return;
      }
      xStart = touches[0].clientX;
    };

    const handleTouchMove = ({ touches }) => {
      if (!xStart) {
        return;
      }
      if (touches.length > 1) {
        return;
      }

      const xEnd = touches[0].clientX;
      const screenWidth = screen.width;
      const windowWidth = window.innerWidth;
      const percentDifference = Math.ceil((screenWidth / windowWidth) * 100);

      if (percentDifference > 125) {
        return;
      }

      if (Math.abs(xEnd - xStart) < 60) {
        return;
      }

      if (xStart < xEnd) {
        handleBackClick();
      } else {
        handleNextClick();
      }

      xStart = null;
    };

    el.addEventListener('touchstart', handleTouchStart);
    document.addEventListener('touchmove', handleTouchMove);

    return () => {
      el.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
    };
  }, [sliderContainer, handleBackClick, handleNextClick]);

  return <SliderSt ref={sliderContainer}>{children}</SliderSt>;
};

export default Slider;
